import { DeviceEnum } from "../../../../redux/slices/environmentSlice";
import Selecto from "react-selecto";
import ContextMenu from "../common/contextMenu/contextMenu.index";
import {
    handleClearAllSelectedResources,
    handleSelectResources,
    handleSetFileManagerView,
    handleSetIsSingleSelect,
    handleSetNextUrl,
    handleSetResources,
    handleSetScrollId
} from "../fileManager.actions";
import { FileManagerView } from "../../../../redux/slices/fileManagerSlice";
import ResourceCard from "../common/resourceCard/resourceCard.index";
import EmptyState from "../../emptyState/emptyState.index";
import searchEmptyState from "../../../../assets/images/svg/searchEmpty.svg";
import { dateOptions, dateRangeCheck, isFolder, searchUrlToString, searchUrlToObject } from "../../../../scripts/helpers";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setContextMenu, syncSearchFileManager } from "../fileManager.function";
import { contextMenuState } from "../common/contextMenu/contextMenu.interface";
import { keyboardHandler } from "../keyboard.functions";
import { handleOnSelectoScroll, selectorCommonProps } from "../selecto.functions";
import { FileManagerModeEnum, HistorySearchEnum } from "../../../../interfaces/general";
import Modals from "../common/modals/modals.index";
import { ReactComponent as ListView } from "../../../../assets/images/fileManager/ListView.svg";
import { ReactComponent as GridView } from "../../../../assets/images/fileManager/GridView.svg";
import FolderLocationModal from "../../../../pages/layout/header/search/folderLocationModal/folderLocationModal.index";
import pdfFileIcon from "../../../../assets/images/fileManager/PdfFileIcon.svg";
import imageFileIcon from "../../../../assets/images/fileManager/ImageFileIcon.svg";
import videoFileIcon from "../../../../assets/images/fileManager/VideoFileIcon.svg";
import musicFileIcon from "../../../../assets/images/fileManager/MusicFileIcon.svg";
import { SearchFilterInterface } from "../../../../pages/search/search.interface";
import { ReactComponent as DropArrow } from "../../../../assets/images/svg/dropArrow.svg";
import PATH from "../../../../urls/path";
import jalMoment from "moment-jalaali";
import line from "../../../../assets/images/svg/line.svg";
import times from "../../../../assets/images/svg/times.svg";
import Button from "../../button/button.index";
import { ButtonSize, ButtonType } from "../../button/button.interface";
import { Menu, MenuItem } from "@szhsin/react-menu";
import GridCardFixer from "../../card/gridCardFixer.index";
import Dialog from "../../dialog/dialog.index";
import { DialogSize } from "../../dialog/dialog.interface";
import { useAppSelector } from "../../../../redux/hooks";
import { shallowEqual } from "react-redux";
import RangePicker from "mobin-range-picker";
import { CalendarOptions, SearchPageType } from "../../../../pages/layout/header/search/search.interface";
import { ReactComponent as Setting } from "../../../../assets/images/svg/setting-4.svg";
import AdvancedSearch from "../../../../pages/layout/header/search/advancedSearch/advancedSearch.index";
import Loader from "../../loader/loader.index";
import Spinner1 from "../../spinners/spinner1/spinner1";
import { post } from "../../../../scripts/api";
import API from "../../../../urls/api";

export const searchTypeOptions = [
    { label: "همه", payload: "*" },
    { icon: pdfFileIcon, label: "PDF", payload: "application/pdf" },
    { icon: imageFileIcon, label: "تصاویر", payload: "image/*" },
    { icon: videoFileIcon, label: "ویدیو", payload: "video/*" },
    { icon: musicFileIcon, label: "موزیک", payload: "audio/*" }
];

export default function SearchFileManager({ pageType }: { pageType: SearchPageType }): JSX.Element {
    const location = useLocation();
    const navigate = useNavigate();
    const fileInput = useRef<any>();
    const folderInput = useRef<any>();
    const selectoRef = useRef<any>();
    const fileManagerScrollerRef = useRef<any>();
    const filtersContainerRef = useRef<any>();

    const [advancedSearchStatus, setAdvancedSearchStatus] = useState(false);
    const { scrollId, resources, filteredResources, selectedResources, view, contextMenuStatus } = useAppSelector(
        ({ fileManager: { scrollId, resources, filteredResources, selectedResources, view, contextMenuStatus } }) => ({
            scrollId,
            resources,
            filteredResources,
            selectedResources,
            view,
            contextMenuStatus
        }),
        shallowEqual
    );
    const { device } = useAppSelector(({ environment: { device } }) => ({ device }), shallowEqual);
    const [selectoRun, setSelectoRun] = useState<boolean>(false);
    const [rangePickerModalStatus, setRangePickerModalStatus] = useState(false);
    const [locationModalStatus, setLocationModalStatus] = useState(false);
    const [filter, setFilter] = useState<SearchFilterInterface | undefined>(undefined);
    const [scrollEnd, setScrollEnd] = useState(false);
    const [filtersSlideArrow, setFiltersSlideArrow] = useState(false);
    const [filterSlideScrollLeft, setFilterSlideScrollLeft] = useState(0);
    const [totalCount, setTotalCount] = useState<number>();
    const [range, setRange] = useState<number[] | undefined>(undefined);

    useEffect(() => {
        handleSetResources(undefined);
        handleSetScrollId(undefined);
        handleSetNextUrl(undefined);
        const searchUrlObject = searchUrlToObject();
        delete searchUrlObject["pageType"];
        setFilter(searchUrlObject);
    }, [location.search]);

    useEffect(() => {
        if (filter) {
            if (filter && filter.dateOption !== undefined) {
                setRange(dateRangeCheck(filter.dateOption, filter.from_created_at, filter.to_created_at));
            }
            const qs = searchUrlToString(filter);
            navigate(`${PATH.search}${qs}pageType:${pageType}`);
        }
    }, [filter, pageType]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        (async () => {
            await syncSearchFileManager(undefined, signal).then((data: any) => {
                if (data) setTotalCount(data?.count);
                const searchUrlObject = searchUrlToObject();
                delete searchUrlObject["pageType"];
                delete searchUrlObject["owners_id"];
                if (Object.keys(searchUrlObject).length) {
                    post((data, status) => {}, API.reporting.createHistorySearch(), {
                        type: HistorySearchEnum.MINE,
                        content: JSON.stringify(searchUrlObject)
                    });
                }
            });
        })();

        return () => {
            controller.abort();
        };
    }, [location.search]);

    useEffect(() => {
        if (!resources) {
            handleSetScrollId(undefined);
        }
    }, [resources]);

    useEffect(() => {
        const fileManagerContainer = document.getElementById("fileManager");
        if (fileManagerContainer) {
            fileManagerContainer.addEventListener("scroll", (e) => {
                setScrollEnd(false);
                if (fileManagerContainer.scrollTop + fileManagerContainer.offsetHeight >= fileManagerContainer.scrollHeight) {
                    setScrollEnd(true);
                }
            });
        }
        return () => {
            fileManagerContainer?.removeEventListener("scroll", () => false);
        };
    });

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        if (scrollEnd && scrollId) {
            (async () => {
                await syncSearchFileManager(scrollId, signal).then((data: any) => {
                    if (data.result?.length === 0) {
                        handleSetScrollId(undefined);
                    }
                });
            })();
        }

        return () => {
            controller.abort();
        };
    }, [scrollEnd]);

    useEffect(() => {
        if (filtersContainerRef.current) {
            filtersContainerRef.current.addEventListener("scroll", (e: any) => {
                setFilterSlideScrollLeft(e.target.scrollLeft);
            });
        }
        return () => {
            if (filtersContainerRef.current) {
                filtersContainerRef.current.removeEventListener("scroll", () => true);
            }
        };
    }, [filtersContainerRef.current]);

    const handleClearSelectedResources = () => {
        if (!selectoRun) {
            handleClearAllSelectedResources();
        }
        setSelectoRun(false);
    };

    const handleOnContextMenu = (e: any) => {
        e.preventDefault();
        if (device === DeviceEnum.desktop) {
            const xPosition = e.pageX;
            const yPosition = e.pageY;
            if (e.target.dataset.resourceId) {
                const id = parseInt(e.target.dataset.resourceId);
                const resources = filteredResources.filter((res) => res.id === id);
                if (selectedResources?.length <= 1) {
                    handleSetIsSingleSelect(true);
                    handleSelectResources(resources);
                    if (isFolder(resources[0])) {
                        setContextMenu(
                            true,
                            { x: xPosition, y: yPosition },
                            resources[0].is_favorite ? contextMenuState.singleFolderSelectedWithFavorite : contextMenuState.singleFolderSelected
                        );
                    } else {
                        setContextMenu(
                            true,
                            { x: xPosition, y: yPosition },
                            resources[0].is_favorite ? contextMenuState.singleFileSelectedWithFavorite : contextMenuState.singleFileSelected
                        );
                    }
                } else {
                    if (selectedResources.every((resource) => isFolder(resource))) {
                        setContextMenu(
                            true,
                            { x: xPosition, y: yPosition },
                            selectedResources.every((resource) => resource.is_favorite)
                                ? contextMenuState.multiFolderSelectedWithFavorite
                                : contextMenuState.multiFolderSelected
                        );
                    } else if (selectedResources.every((resource) => !isFolder(resource))) {
                        setContextMenu(
                            true,
                            { x: xPosition, y: yPosition },
                            selectedResources.every((resource) => resource.is_favorite)
                                ? contextMenuState.multiFileSelectedWithFavorite
                                : contextMenuState.multiFileSelected
                        );
                    } else {
                        setContextMenu(
                            true,
                            { x: xPosition, y: yPosition },
                            selectedResources.every((resource) => resource.is_favorite)
                                ? contextMenuState.multiFolderSelectedWithFavorite
                                : contextMenuState.multiFolderSelected
                        );
                    }
                }
            }
        }
    };

    const handleOnScroll = () => {
        if (device === DeviceEnum.desktop) {
            selectoRef.current?.checkScroll();
        }
    };

    const handleOnClick = () => {
        if (device === DeviceEnum.desktop) {
            handleClearSelectedResources();
        }
    };

    const handleNextFilter = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        filtersContainerRef.current.scrollLeft -= filtersContainerRef.current.clientWidth;
    };

    const handlePrevFilter = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        filtersContainerRef.current.scrollLeft += filtersContainerRef.current.clientWidth;
    };

    if (!filter) return <></>;
    return (
        <>
            <div className="h-full">
                {device === DeviceEnum.desktop && resources && (
                    <Selecto
                        {...selectorCommonProps}
                        ref={selectoRef}
                        onSelectStart={() => setSelectoRun(true)}
                        onScroll={(e) => handleOnSelectoScroll(e, fileManagerScrollerRef)}
                        scrollOptions={{
                            container: fileManagerScrollerRef.current,
                            throttleTime: 10,
                            threshold: 0
                        }}
                    />
                )}
                <ContextMenu fileInput={fileInput} folderInput={folderInput} mode={FileManagerModeEnum.MAIN} />
                {
                    <div className="flex flex-col h-full w-full">
                        {/* header */}
                        <div className="flex flex-col gap-4 md:gap-8">
                            <div className="flex items-center justify-between">
                                {/* total count */}
                                <p className="text-secondary-500 text-sm gap-1 font-normal flex items-center justify-start">
                                    تعداد نتایج یافت شده:{" "}
                                    <span className="text-secondary-800 font-bold text-[18px]">
                                        {resources === undefined || totalCount === undefined ? (
                                            <Spinner1 className="size-5 mr-0.5" />
                                        ) : (
                                            totalCount || "0"
                                        )}
                                    </span>
                                </p>

                                {/* view */}
                                <div className="flex items-center gap-1 shrink-0">
                                    <span className="text-[14px] text-secondary-500 hidden md:block">حالت نمایش</span>
                                    <div
                                        className="w-[36px] h-[36px] hover:bg-[#EFF0F6] rounded-[10px] flex items-center justify-center cursor-pointer transition-all"
                                        onClick={() => handleSetFileManagerView(FileManagerView.list)}
                                    >
                                        <ListView
                                            className={`${view === FileManagerView.list ? "fill-primary-600" : "fill-[#A0A3BD]"}`}
                                            width="25px"
                                            height="25px"
                                        />
                                    </div>
                                    <div
                                        className="w-[36px] h-[36px] hover:bg-[#EFF0F6] rounded-[10px] flex items-center justify-center cursor-pointer transition-all"
                                        onClick={() => handleSetFileManagerView(FileManagerView.grid)}
                                    >
                                        <GridView
                                            className={`${view === FileManagerView.grid ? "fill-primary-600" : "fill-[#A0A3BD]"}`}
                                            width="25px"
                                            height="25px"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* filter */}

                            <div className="flex items-center justify-between gap-4 mb-4 sm:mb-0">
                                <div className="items-center gap-2 hidden overflow-auto lg:flex">
                                    <div className="relative overflow-auto">
                                        <div className="flex items-center gap-2 overflow-auto no-scrollbar" ref={filtersContainerRef}>
                                            {filtersSlideArrow && (
                                                <>
                                                    {Math.abs(filterSlideScrollLeft - filtersContainerRef.current.clientWidth) !==
                                                        filtersContainerRef.current.scrollWidth && (
                                                        <div
                                                            className="w-[25px] h-[25px] flex items-center justify-center cursor-pointer transition hover:scale-[1.2] drop-shadow-lg bg-white absolute bottom-[7px] left-2 rounded-full"
                                                            onClick={handleNextFilter}
                                                        >
                                                            <span className="rotate-90">
                                                                <DropArrow />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {filterSlideScrollLeft !== 0 && (
                                                        <div
                                                            className="w-[25px] h-[25px] flex items-center justify-center cursor-pointer transition hover:scale-[1.2] drop-shadow-lg bg-white absolute bottom-[7px] right-2 rounded-full"
                                                            onClick={handlePrevFilter}
                                                        >
                                                            <span className="-rotate-90">
                                                                <DropArrow />
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            <Menu
                                                onItemClick={(e) => setFilter({ ...filter, type: e.value })}
                                                portal
                                                menuButton={
                                                    <div
                                                        className={`min-w-[150px] h-[40px] text-[14px] flex items-center rounded-[10px] px-4 gap-4 shrink-0 justify-between cursor-pointer bg-primary-50 text-primary-600 !border-[#EDF6FF]`}
                                                    >
                                                        <span>
                                                            {searchTypeOptions.find((item) => item.payload === filter.type)?.label ||
                                                                searchTypeOptions[0].label}
                                                        </span>
                                                        <DropArrow className="stroke-primary-600" />
                                                        {filter.type && filter.type !== "*" && (
                                                            <>
                                                                <img src={line} alt="line" />
                                                                <img
                                                                    src={times}
                                                                    alt="times"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        setFilter({ ...filter, type: "*" });
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                }
                                            >
                                                {searchTypeOptions.map((item) => {
                                                    return (
                                                        <MenuItem key={item.payload} value={item.payload}>
                                                            <div className="flex items-center gap-4">
                                                                {item.icon && <img className="w-[24px] h-[24px]" src={item.icon} alt={item.label} />}
                                                                <span className="text-[14px]">{item.label}</span>
                                                            </div>
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Menu>
                                            <div
                                                className={`text-[14px] gap-4 shrink-0 rounded-[10px] border-2 border-secondary-300 px-4 !h-[40px] flex items-center justify-between cursor-pointer ${filter.parent_id && "bg-primary-50 text-primary-600 border-[#EDF6FF]"}`}
                                                onClick={() => setLocationModalStatus(true)}
                                            >
                                                <span>
                                                    {filter.parent_name !== "null" && filter.parent_name ? filter.parent_name : "فایل‌های من"}
                                                </span>
                                                <DropArrow className={filter.parent_id ? "stroke-primary-600" : "stroke-gray-500"} />
                                                {filter.parent_id && (
                                                    <>
                                                        <img src={line} alt="line" />
                                                        <img
                                                            src={times}
                                                            alt="times"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setFilter({ ...filter, parent_id: undefined, parent_name: undefined });
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                            {!!range && (
                                                <div
                                                    className={`text-[14px] gap-4 shrink-0 rounded-[10px] border-2 border-secondary-300 px-4 !h-[40px] flex items-center justify-between cursor-pointer ${filter.from_created_at && "bg-primary-50 text-primary-600 border-[#EDF6FF]"}`}
                                                    onClick={() => setRangePickerModalStatus(true)}
                                                >
                                                    <span>
                                                        {range
                                                            ? `${jalMoment.unix(range[0]).format("jD jMMMM jYYYY")} تا ${jalMoment.unix(range[1]).format("jD jMMMM jYYYY")}`
                                                            : "تاریخ"}
                                                    </span>
                                                    <DropArrow className={range ? "stroke-primary-600" : "stroke-gray-500"} />
                                                    {range && (
                                                        <>
                                                            <img src={line} alt="line" />
                                                            <img
                                                                src={times}
                                                                alt="times"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setFilter({
                                                                        ...filter,
                                                                        dateOption: undefined,
                                                                        from_created_at: undefined,
                                                                        to_created_at: undefined,
                                                                        range: undefined
                                                                    });
                                                                    setRange(undefined);
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                            {filter.is_trash && (
                                                <div
                                                    className={`text-[14px] gap-4 shrink-0 rounded-[10px] border-2 px-4 !h-[40px] flex items-center justify-between cursor-pointer bg-primary-50 text-primary-600 border-[#EDF6FF]`}
                                                >
                                                    <span>سطل زباله</span>
                                                    <img src={line} alt="line" />
                                                    <img
                                                        src={times}
                                                        alt="times"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setFilter({ ...filter, is_trash: undefined });
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            {filter.is_favorite && (
                                                <div
                                                    className={`text-[14px] gap-4 shrink-0 rounded-[10px] border-2 px-4 !h-[40px] flex items-center justify-between cursor-pointer bg-primary-50 text-primary-600 border-[#EDF6FF]`}
                                                >
                                                    <span>علاقه‌مندی‌ها</span>
                                                    <img src={line} alt="line" />
                                                    <img
                                                        src={times}
                                                        alt="times"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setFilter({ ...filter, is_favorite: undefined });
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <Button
                                        className="shrink-0"
                                        autoFocus={false}
                                        text="حذف فیلترها"
                                        size={ButtonSize.SM}
                                        type={ButtonType.TEXT}
                                        onClick={() => {
                                            setFilter({});
                                            setRange(undefined);
                                        }}
                                    />
                                </div>

                                <Button
                                    onClick={() => setAdvancedSearchStatus(true)}
                                    size={ButtonSize.SM}
                                    autoFocus={false}
                                    type={device === DeviceEnum.mobile ? ButtonType.PRIMARY : ButtonType.SECONDARY}
                                    icon={<Setting className="stroke-current" />}
                                    className="w-full lg:w-fit"
                                    text="فیلتر ها"
                                />
                            </div>
                        </div>
                        <div>
                            <FolderLocationModal
                                showFolderLocationModal={locationModalStatus}
                                setShowFolderLocationModal={() => setLocationModalStatus(false)}
                                handleGetFolderLocation={(parent_id, parent_name) =>
                                    setFilter({ ...filter, parent_id: parent_id ? parent_id : null, parent_name: parent_name })
                                }
                            />
                        </div>
                        <div
                            onClick={handleOnClick}
                            onContextMenu={handleOnContextMenu}
                            onKeyDown={(e) => keyboardHandler(e, navigate, location)}
                            tabIndex={0}
                            ref={fileManagerScrollerRef}
                            onScroll={handleOnScroll}
                            className={`sm:py-6 no-scrollbar border-4 border-transparent border-dashed flex-1 rounded-[10px] ${contextMenuStatus ? "overflow-hidden" : "overflow-auto"}`}
                            id="fileManager"
                        >
                            {view === FileManagerView.list && resources && resources?.length > 0 && (
                                <div className="hidden lg:grid grid-cols-5 gap-2 px-4 pb-4">
                                    <div className="col-span-2" />
                                    <div className="text-[14px] text-secondary-500">آخرین ویرایش</div>
                                    <div className="text-[14px] text-secondary-500">حجم فایل</div>
                                    <div className="text-[14px] text-secondary-500">تاریخ ایجاد</div>
                                </div>
                            )}
                            <div
                                className={`${resources?.length !== 0 ? `sm:flex sm:flex-wrap sm:justify-between gap-x-4 ${view === FileManagerView.list && "flex-col"} ${view === FileManagerView.grid && "grid grid-cols-2"}` : "h-full"}`}
                                id="resources"
                            >
                                {resources === undefined ? (
                                    Array.from(Array(10).keys()).map((item, i) =>
                                        view === FileManagerView.grid ? (
                                            <div
                                                key={i}
                                                className="h-[140px] min-w-[120px] md:min-w-[200px] flex-1 rounded-[10px] overflow-hidden mb-4 shadow-sm relative transition-all border border-transparent skeleton"
                                            />
                                        ) : (
                                            <div
                                                key={i}
                                                className="w-full !h-[60px] rounded-[10px] mb-4 lg:mb-1 p-4 lg:py-3 lg:px-4 overflow-hidden relative transition-all group border border-transparent skeleton"
                                            />
                                        )
                                    )
                                ) : resources?.length > 0 ? (
                                    filteredResources.map((resource, index) => (
                                        <ResourceCard
                                            resource={resource}
                                            view={view}
                                            key={resource.id}
                                            index={index}
                                            mode={FileManagerModeEnum.MAIN}
                                        />
                                    ))
                                ) : (
                                    <EmptyState
                                        icon={searchEmptyState}
                                        title="نتیجه‌ای یافت نشد."
                                        text="کلمهٔ دیگری امتحان کنید یا بر اساس نام مالک یا با استفاده فیلترها کلمات کلیدی را در فایل‌ها جستجو کنید."
                                        buttonText=""
                                        buttonAction={() => false}
                                    />
                                )}
                                {view === FileManagerView.grid && Array.from(Array(20).keys()).map((item, i) => <GridCardFixer key={i} />)}
                                {!!scrollId && !!resources?.length && <Loader hiddenLogo />}
                            </div>
                        </div>
                    </div>
                }
                <Modals />
            </div>
            <Dialog status={rangePickerModalStatus} size={DialogSize.MD} title="انتخاب زمان" onClose={() => setRangePickerModalStatus(false)}>
                <RangePicker
                    range={range}
                    className="sm:px-11 py-4"
                    buttonClassname="mx-1"
                    options={dateOptions
                        .filter((date) => date.label !== CalendarOptions.ALL_DAYS)
                        .map((date) => ({
                            lable: date.label,
                            start: date.payload ? date.payload[0] : null,
                            end: date.payload ? date.payload[1] : null
                        }))}
                    onSelect={(range, selectedOption) => {
                        if (range) {
                            if (selectedOption !== CalendarOptions.CUSTOM) {
                                setFilter({
                                    ...filter,
                                    dateOption: selectedOption! as CalendarOptions,
                                    from_created_at: range.start!,
                                    to_created_at: range.end!,
                                    range: false
                                });
                            } else {
                                setFilter({
                                    ...filter,
                                    dateOption: selectedOption! as CalendarOptions,
                                    from_created_at: range.start!,
                                    to_created_at: range.end!,
                                    range: true
                                });
                            }
                            setRange([range.start!, range.end!]);
                        }
                        setRangePickerModalStatus(false);
                    }}
                />
            </Dialog>
            <AdvancedSearch
                setSearchFilter={setFilter}
                searchFilters={filter}
                drawerStatus={advancedSearchStatus}
                onClose={() => setAdvancedSearchStatus(false)}
            />
        </>
    );
}
